// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewOptionsPanel_root__KlB39 {
  display: inline-block;
  width: auto;
}

.ViewOptionsPanel_trigger__1aeWx {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border, #e2e5e8);
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--m-text, #495057);
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  white-space: nowrap;
}
.ViewOptionsPanel_trigger__1aeWx:hover {
  border-color: var(--m-primary, #00b4f3);
  background: var(--m-background-subtle-primary, #f8fafc);
}

.ViewOptionsPanel_triggerOpen__owfWf {
  border-color: var(--m-primary, #00b4f3);
  background: var(--m-background-subtle-primary, #f8fafc);
}

.ViewOptionsPanel_triggerLabel__6EN4r {
  flex: 1 1;
}

.ViewOptionsPanel_badge__BE-g2 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  background: var(--m-primary, #00b4f3);
  color: #fff;
}

.ViewOptionsPanel_chevron__qYOnn {
  transition: transform 0.2s ease;
  opacity: 0.6;
}

.ViewOptionsPanel_chevronOpen__7xMb- {
  transform: rotate(180deg);
}

.ViewOptionsPanel_panel__SDiPk {
  width: 340px;
  max-width: calc(100vw - 24px);
  max-height: min(80vh, 640px);
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.ViewOptionsPanel_themeScope__mD8Mr {
  display: flex;
  flex-direction: column;
  max-height: min(80vh, 640px);
  background: var(--m-card-background-color, #fff);
  border: 1px solid var(--m-border, #d0d5dd);
  border-radius: 10px;
  box-shadow: var(--m-dropdown-shadow, 0 8px 24px rgba(0, 0, 0, 0.12));
  overflow: hidden;
  animation: ViewOptionsPanel_slideDown__4a61D 0.18s ease-out;
}

.ViewOptionsPanel_dropdownShell__BfPUb > .dropdown__content-inner {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
}
.ViewOptionsPanel_dropdownShell__BfPUb .dropdown__items-container {
  overflow: visible;
  max-height: none !important;
}

@keyframes ViewOptionsPanel_slideDown__4a61D {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.ViewOptionsPanel_body__igBEZ {
  flex: 1 1;
  overflow-y: auto;
  padding: 4px 0;
  background: var(--m-card-background-color, #fff);
}
.ViewOptionsPanel_body__igBEZ::-webkit-scrollbar {
  width: 4px;
}
.ViewOptionsPanel_body__igBEZ::-webkit-scrollbar-thumb {
  background: var(--m-scrollbar-color-hovered, #cbd5e1);
  border-radius: 2px;
}

.ViewOptionsPanel_footer__nLaek {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  border-top: 1px solid var(--m-border, #d0d5dd);
  background: var(--m-subtle-card-background-color, #f4f6fa);
}

.ViewOptionsPanel_footerClear__f2h9q {
  background: none;
  border: none;
  color: var(--m-text-muted, #6a768b);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 6px;
  transition: color 0.15s, background 0.15s;
}
.ViewOptionsPanel_footerClear__f2h9q:hover {
  color: var(--m-text, #162949);
  background: var(--m-dropdown-hover, #f6f7fb);
}

.ViewOptionsPanel_footerApply__pGOV6 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  background: var(--m-primary, #00b4f3);
  color: #fff;
  transition: opacity 0.15s;
}
.ViewOptionsPanel_footerApply__pGOV6:hover {
  opacity: 0.9;
}

.ViewOptionsPanel_section__OVokj {
  border-bottom: 1px solid var(--m-border, #d0d5dd);
}
.ViewOptionsPanel_section__OVokj:last-child {
  border-bottom: none;
}

.ViewOptionsPanel_sectionHeader__YRNWj {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 14px;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--m-text, #162949);
  font-size: 13px;
  font-weight: 600;
  text-align: left;
  transition: background 0.12s;
}
.ViewOptionsPanel_sectionHeader__YRNWj:hover {
  background: var(--m-dropdown-hover, #f6f7fb);
}

.ViewOptionsPanel_sectionHeaderLeft__Vjdo\\+ {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ViewOptionsPanel_sectionReset__DAI3A {
  font-size: 11px;
  font-weight: 500;
  color: var(--m-text-muted, #6a768b);
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
}
.ViewOptionsPanel_sectionReset__DAI3A:hover {
  color: var(--m-primary, #00b4f3);
}

.ViewOptionsPanel_sectionChevron__AFO-3 {
  color: var(--m-text-muted, #6a768b);
  transition: transform 0.2s;
  flex-shrink: 0;
}

.ViewOptionsPanel_sectionChevronOpen__dGNNO {
  transform: rotate(180deg);
}

.ViewOptionsPanel_sectionBody__Ohyee {
  padding: 0 14px 12px;
}

.ViewOptionsPanel_chipGrid__PksxN {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ViewOptionsPanel_chip__bfT54 {
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid var(--m-border, #d0d5dd);
  background: var(--m-subtle-card-background-color, #f4f6fa);
  color: var(--m-text-muted, #6a768b);
  cursor: pointer;
  transition: border-color 0.12s, background 0.12s, color 0.12s;
  outline: none;
}
.ViewOptionsPanel_chip__bfT54:hover {
  border-color: var(--m-primary, #00b4f3);
  color: var(--m-text, #162949);
}

.ViewOptionsPanel_chipActive__puQN7 {
  background: var(--m-primary, #00b4f3);
  border-color: var(--m-primary, #00b4f3);
  color: #fff;
}

.ViewOptionsPanel_radioList__Q3Cxm {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ViewOptionsPanel_radioItem__FgoYR {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 4px;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: var(--m-text, #162949);
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  transition: background 0.12s;
}
.ViewOptionsPanel_radioItem__FgoYR:hover {
  background: var(--m-dropdown-hover, #f6f7fb);
}

.ViewOptionsPanel_radioCircle__dEx4A {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid var(--m-border, #d0d5dd);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.12s, background 0.12s;
}

.ViewOptionsPanel_radioCircleActive__YuRlH {
  border-color: var(--m-primary, #00b4f3);
  background: var(--m-primary, #00b4f3);
  color: #fff;
}

.ViewOptionsPanel_checkList__gQ75l {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ViewOptionsPanel_checkItem__NwN0e {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 4px;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: var(--m-text, #162949);
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  transition: background 0.12s;
}
.ViewOptionsPanel_checkItem__NwN0e:hover {
  background: var(--m-dropdown-hover, #f6f7fb);
}

.ViewOptionsPanel_checkBox__tDV8g {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 2px solid var(--m-border, #d0d5dd);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.12s, background 0.12s;
}

.ViewOptionsPanel_checkBoxActive__cBNiF {
  border-color: var(--m-primary, #00b4f3);
  background: var(--m-primary, #00b4f3);
  color: #fff;
}

.ViewOptionsPanel_dateFields__mDxg2 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ViewOptionsPanel_dateField__ldAH2 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ViewOptionsPanel_dateLabel__3agyn {
  font-size: 11px;
  font-weight: 600;
  color: var(--m-text-muted, #6a768b);
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.ViewOptionsPanel_dateInput__fjRQ- {
  width: 100%;
  padding: 7px 10px;
  border-radius: 6px;
  border: 1px solid var(--m-border, #d0d5dd);
  background: var(--m-card-background-color, #fff);
  color: var(--m-text, #162949);
  font-size: 13px;
  outline: none;
}
.ViewOptionsPanel_dateInput__fjRQ-:focus {
  border-color: var(--m-primary, #00b4f3);
}

.ViewOptionsPanel_filterSectionBody__a9TDb {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ViewOptionsPanel_filterScrollList__ckV9x {
  max-height: 240px;
  overflow-y: auto;
  margin: 0 -2px;
  padding: 0 2px;
}
.ViewOptionsPanel_filterScrollList__ckV9x::-webkit-scrollbar {
  width: 4px;
}
.ViewOptionsPanel_filterScrollList__ckV9x::-webkit-scrollbar-thumb {
  background: var(--m-scrollbar-color-hovered, #cbd5e1);
  border-radius: 2px;
}

.ViewOptionsPanel_picker__8o-Xo {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ViewOptionsPanel_pickerSummary__sVHZO {
  padding: 8px 10px;
  border-radius: 6px;
  background: var(--m-subtle-card-background-color, #f4f6fa);
  border: 1px solid var(--m-border, #d0d5dd);
  font-size: 12px;
  font-weight: 600;
  color: var(--m-text, #162949);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ViewOptionsPanel_pickerSearchWrap__zho8x {
  position: relative;
}

.ViewOptionsPanel_pickerSearchIcon__QlZBk {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--m-text-muted, #6a768b);
  pointer-events: none;
}

.ViewOptionsPanel_pickerSearch__RW0hy {
  width: 100%;
  padding: 8px 10px 8px 32px;
  border-radius: 6px;
  border: 1px solid var(--m-border, #d0d5dd);
  background: var(--m-card-background-color, #fff);
  color: var(--m-text, #162949);
  font-size: 13px;
  outline: none;
}
.ViewOptionsPanel_pickerSearch__RW0hy:focus {
  border-color: var(--m-primary, #00b4f3);
}
.ViewOptionsPanel_pickerSearch__RW0hy::-webkit-search-cancel-button {
  cursor: pointer;
}

.ViewOptionsPanel_pickerList__Gp1OQ {
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-height: 240px;
  overflow-y: auto;
  margin: 0 -2px;
  padding: 0 2px;
}
.ViewOptionsPanel_pickerList__Gp1OQ::-webkit-scrollbar {
  width: 4px;
}
.ViewOptionsPanel_pickerList__Gp1OQ::-webkit-scrollbar-thumb {
  background: var(--m-scrollbar-color-hovered, #cbd5e1);
  border-radius: 2px;
}

.ViewOptionsPanel_pickerItem__ojuxm {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 7px 4px;
  background: none;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  color: var(--m-text, #162949);
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  transition: background 0.12s;
}
.ViewOptionsPanel_pickerItem__ojuxm:hover {
  background: var(--m-dropdown-hover, #f6f7fb);
}

.ViewOptionsPanel_pickerItemLabel__2cliD {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ViewOptionsPanel_pickerHint__U-k0K {
  padding: 10px 4px;
  font-size: 12px;
  color: var(--m-text-muted, #6a768b);
  text-align: center;
}

.ViewOptionsPanel_periodDate__keCcS {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ViewOptionsPanel_periodDateSelector__lCoqH {
  width: 100%;
  max-width: 100%;
}

.ViewOptionsPanel_periodModeRow__qI8J\\+ {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ViewOptionsPanel_periodNavRow__mLrod {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 4px;
  border-radius: 8px;
  background: var(--m-subtle-card-background-color, #f4f6fa);
  border: 1px solid var(--m-border, #d0d5dd);
}

.ViewOptionsPanel_periodNavBtn__yF9CD {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: var(--m-card-background-color, #fff);
  color: var(--m-text, #162949);
  cursor: pointer;
  flex-shrink: 0;
  transition: border-color 0.12s, background 0.12s;
}
.ViewOptionsPanel_periodNavBtn__yF9CD:hover:not(:disabled) {
  border-color: var(--m-primary, #00b4f3);
  color: var(--m-primary, #00b4f3);
}
.ViewOptionsPanel_periodNavBtn__yF9CD:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.ViewOptionsPanel_periodNavLabel__OG-q- {
  flex: 1 1;
  min-width: 0;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ViewOptionsPanel_periodNavPrimary__RSyJK {
  font-size: 13px;
  font-weight: 600;
  color: var(--m-text, #162949);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ViewOptionsPanel_periodNavSub__dioke {
  font-size: 11px;
  font-weight: 500;
  color: var(--m-text-muted, #6a768b);
}

.ViewOptionsPanel_periodSummary__asXvB {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px;
  border-radius: 6px;
  background: var(--m-subtle-card-background-color, #f4f6fa);
  border: 1px solid var(--m-border, #d0d5dd);
}

.ViewOptionsPanel_periodSummaryLabel__6wWgV {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--m-text-muted, #6a768b);
}

.ViewOptionsPanel_periodSummaryValue__1KUAO {
  font-size: 12px;
  font-weight: 600;
  color: var(--m-text, #162949);
}

.ViewOptionsPanel_periodTodayLink__FY9YV {
  align-self: flex-start;
  padding: 0;
  border: none;
  background: none;
  font-size: 12px;
  font-weight: 600;
  color: var(--m-primary, #00b4f3);
  cursor: pointer;
}
.ViewOptionsPanel_periodTodayLink__FY9YV:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .ViewOptionsPanel_themeScope__mD8Mr {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    top: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    border-radius: 12px 12px 0 0;
    max-height: 85vh;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/ViewOptionsPanel/ViewOptionsPanel.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,WAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gDAAA;EACA,0CAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,gDAAA;EACA,mBAAA;AACF;AACE;EACE,uCAAA;EACA,uDAAA;AACJ;;AAGA;EACE,uCAAA;EACA,uDAAA;AAAF;;AAGA;EACE,SAAA;AAAF;;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,qCAAA;EACA,WAAA;AAAF;;AAGA;EACE,+BAAA;EACA,YAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,YAAA;EACA,6BAAA;EACA,4BAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,gDAAA;EACA,0CAAA;EACA,mBAAA;EACA,oEAAA;EACA,gBAAA;EACA,2DAAA;AAAF;;AAIE;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;AADJ;AAIE;EACE,iBAAA;EACA,2BAAA;AAFJ;;AAMA;EACE;IACE,UAAA;IACA,2BAAA;EAHF;EAKA;IACE,UAAA;IACA,wBAAA;EAHF;AACF;AAMA;EACE,SAAA;EACA,gBAAA;EACA,cAAA;EACA,gDAAA;AAJF;AAME;EACE,UAAA;AAJJ;AAOE;EACE,qDAAA;EACA,kBAAA;AALJ;;AASA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,8CAAA;EACA,0DAAA;AANF;;AASA;EACE,gBAAA;EACA,YAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AANF;AAQE;EACE,6BAAA;EACA,4CAAA;AANJ;;AAUA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qCAAA;EACA,WAAA;EACA,yBAAA;AAPF;AASE;EACE,YAAA;AAPJ;;AAaA;EACE,iDAAA;AAVF;AAYE;EACE,mBAAA;AAVJ;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AAXF;AAaE;EACE,4CAAA;AAXJ;;AAeA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAZF;;AAeA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAZF;AAcE;EACE,gCAAA;AAZJ;;AAgBA;EACE,mCAAA;EACA,0BAAA;EACA,cAAA;AAbF;;AAgBA;EACE,yBAAA;AAbF;;AAgBA;EACE,oBAAA;AAbF;;AAkBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAfF;;AAkBA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;EACA,0DAAA;EACA,mCAAA;EACA,eAAA;EACA,6DAAA;EACA,aAAA;AAfF;AAiBE;EACE,uCAAA;EACA,6BAAA;AAfJ;;AAmBA;EACE,qCAAA;EACA,uCAAA;EACA,WAAA;AAhBF;;AAqBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AAlBF;AAoBE;EACE,4CAAA;AAlBJ;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gDAAA;AAnBF;;AAsBA;EACE,uCAAA;EACA,qCAAA;EACA,WAAA;AAnBF;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AArBF;AAuBE;EACE,4CAAA;AArBJ;;AAyBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gDAAA;AAtBF;;AAyBA;EACE,uCAAA;EACA,qCAAA;EACA,WAAA;AAtBF;;AA2BA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAxBF;;AA2BA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;EACA,yBAAA;EACA,qBAAA;AAxBF;;AA2BA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gDAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;AAxBF;AA0BE;EACE,uCAAA;AAxBJ;;AA8BA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA3BF;;AA8BA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AA3BF;AA6BE;EACE,UAAA;AA3BJ;AA8BE;EACE,qDAAA;EACA,kBAAA;AA5BJ;;AAgCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA7BF;;AAgCA;EACE,iBAAA;EACA,kBAAA;EACA,0DAAA;EACA,0CAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA7BF;;AAgCA;EACE,kBAAA;AA7BF;;AAgCA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,oBAAA;AA7BF;;AAgCA;EACE,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,0CAAA;EACA,gDAAA;EACA,6BAAA;EACA,eAAA;EACA,aAAA;AA7BF;AA+BE;EACE,uCAAA;AA7BJ;AAgCE;EACE,eAAA;AA9BJ;;AAkCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AA/BF;AAiCE;EACE,UAAA;AA/BJ;AAkCE;EACE,qDAAA;EACA,kBAAA;AAhCJ;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;AAjCF;AAmCE;EACE,4CAAA;AAjCJ;;AAqCA;EACE,SAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlCF;;AAqCA;EACE,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;AAlCF;;AAuCA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AApCF;;AAuCA;EACE,WAAA;EACA,eAAA;AApCF;;AAuCA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AApCF;;AAuCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,0DAAA;EACA,0CAAA;AApCF;;AAuCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,gDAAA;EACA,6BAAA;EACA,eAAA;EACA,cAAA;EACA,gDAAA;AApCF;AAsCE;EACE,uCAAA;EACA,gCAAA;AApCJ;AAuCE;EACE,aAAA;EACA,mBAAA;AArCJ;;AAyCA;EACE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAtCF;;AAyCA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAtCF;;AAyCA;EACE,eAAA;EACA,gBAAA;EACA,mCAAA;AAtCF;;AAyCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,0DAAA;EACA,0CAAA;AAtCF;;AAyCA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mCAAA;AAtCF;;AAyCA;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AAtCF;;AAyCA;EACE,sBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;AAtCF;AAwCE;EACE,0BAAA;AAtCJ;;AA0CA;EACE;IACE,0BAAA;IACA,oBAAA;IACA,kBAAA;IACA,mBAAA;IACA,oBAAA;IACA,sBAAA;IACA,0BAAA;IACA,4BAAA;IACA,gBAAA;EAvCF;AACF","sourcesContent":[".root {\n  display: inline-block;\n  width: auto;\n}\n\n.trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px;\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border, #e2e5e8);\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--m-text, #495057);\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n  white-space: nowrap;\n\n  &:hover {\n    border-color: var(--m-primary, #00b4f3);\n    background: var(--m-background-subtle-primary, #f8fafc);\n  }\n}\n\n.triggerOpen {\n  border-color: var(--m-primary, #00b4f3);\n  background: var(--m-background-subtle-primary, #f8fafc);\n}\n\n.triggerLabel {\n  flex: 1;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  background: var(--m-primary, #00b4f3);\n  color: #fff;\n}\n\n.chevron {\n  transition: transform 0.2s ease;\n  opacity: 0.6;\n}\n\n.chevronOpen {\n  transform: rotate(180deg);\n}\n\n.panel {\n  width: 340px;\n  max-width: calc(100vw - 24px);\n  max-height: min(80vh, 640px);\n  padding: 0;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.themeScope {\n  display: flex;\n  flex-direction: column;\n  max-height: min(80vh, 640px);\n  background: var(--m-card-background-color, #fff);\n  border: 1px solid var(--m-border, #d0d5dd);\n  border-radius: 10px;\n  box-shadow: var(--m-dropdown-shadow, 0 8px 24px rgba(0, 0, 0, 0.12));\n  overflow: hidden;\n  animation: slideDown 0.18s ease-out;\n}\n\n.dropdownShell {\n  > :global(.dropdown__content-inner) {\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    padding: 0;\n  }\n\n  :global(.dropdown__items-container) {\n    overflow: visible;\n    max-height: none !important;\n  }\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 4px 0;\n  background: var(--m-card-background-color, #fff);\n\n  &::-webkit-scrollbar {\n    width: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: var(--m-scrollbar-color-hovered, #cbd5e1);\n    border-radius: 2px;\n  }\n}\n\n.footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 10px 12px;\n  border-top: 1px solid var(--m-border, #d0d5dd);\n  background: var(--m-subtle-card-background-color, #f4f6fa);\n}\n\n.footerClear {\n  background: none;\n  border: none;\n  color: var(--m-text-muted, #6a768b);\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 6px 8px;\n  border-radius: 6px;\n  transition: color 0.15s, background 0.15s;\n\n  &:hover {\n    color: var(--m-text, #162949);\n    background: var(--m-dropdown-hover, #f6f7fb);\n  }\n}\n\n.footerApply {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  border: none;\n  border-radius: 7px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  background: var(--m-primary, #00b4f3);\n  color: #fff;\n  transition: opacity 0.15s;\n\n  &:hover {\n    opacity: 0.9;\n  }\n}\n\n// ─── Collapsible section ─────────────────────────────────────────────────────\n\n.section {\n  border-bottom: 1px solid var(--m-border, #d0d5dd);\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.sectionHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 10px 14px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: var(--m-text, #162949);\n  font-size: 13px;\n  font-weight: 600;\n  text-align: left;\n  transition: background 0.12s;\n\n  &:hover {\n    background: var(--m-dropdown-hover, #f6f7fb);\n  }\n}\n\n.sectionHeaderLeft {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.sectionReset {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--m-text-muted, #6a768b);\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 2px 6px;\n  border-radius: 4px;\n\n  &:hover {\n    color: var(--m-primary, #00b4f3);\n  }\n}\n\n.sectionChevron {\n  color: var(--m-text-muted, #6a768b);\n  transition: transform 0.2s;\n  flex-shrink: 0;\n}\n\n.sectionChevronOpen {\n  transform: rotate(180deg);\n}\n\n.sectionBody {\n  padding: 0 14px 12px;\n}\n\n// ─── Column chips ────────────────────────────────────────────────────────────\n\n.chipGrid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.chip {\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  border: 1px solid var(--m-border, #d0d5dd);\n  background: var(--m-subtle-card-background-color, #f4f6fa);\n  color: var(--m-text-muted, #6a768b);\n  cursor: pointer;\n  transition: border-color 0.12s, background 0.12s, color 0.12s;\n  outline: none;\n\n  &:hover {\n    border-color: var(--m-primary, #00b4f3);\n    color: var(--m-text, #162949);\n  }\n}\n\n.chipActive {\n  background: var(--m-primary, #00b4f3);\n  border-color: var(--m-primary, #00b4f3);\n  color: #fff;\n}\n\n// ─── Radio list ──────────────────────────────────────────────────────────────\n\n.radioList {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.radioItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 7px 4px;\n  background: none;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  color: var(--m-text, #162949);\n  font-size: 13px;\n  font-weight: 500;\n  text-align: left;\n  transition: background 0.12s;\n\n  &:hover {\n    background: var(--m-dropdown-hover, #f6f7fb);\n  }\n}\n\n.radioCircle {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid var(--m-border, #d0d5dd);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: border-color 0.12s, background 0.12s;\n}\n\n.radioCircleActive {\n  border-color: var(--m-primary, #00b4f3);\n  background: var(--m-primary, #00b4f3);\n  color: #fff;\n}\n\n// ─── Multi-select list ───────────────────────────────────────────────────────\n\n.checkList {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.checkItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 7px 4px;\n  background: none;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  color: var(--m-text, #162949);\n  font-size: 13px;\n  font-weight: 500;\n  text-align: left;\n  transition: background 0.12s;\n\n  &:hover {\n    background: var(--m-dropdown-hover, #f6f7fb);\n  }\n}\n\n.checkBox {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  border: 2px solid var(--m-border, #d0d5dd);\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: border-color 0.12s, background 0.12s;\n}\n\n.checkBoxActive {\n  border-color: var(--m-primary, #00b4f3);\n  background: var(--m-primary, #00b4f3);\n  color: #fff;\n}\n\n// ─── Date range ──────────────────────────────────────────────────────────────\n\n.dateFields {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.dateField {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dateLabel {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--m-text-muted, #6a768b);\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.dateInput {\n  width: 100%;\n  padding: 7px 10px;\n  border-radius: 6px;\n  border: 1px solid var(--m-border, #d0d5dd);\n  background: var(--m-card-background-color, #fff);\n  color: var(--m-text, #162949);\n  font-size: 13px;\n  outline: none;\n\n  &:focus {\n    border-color: var(--m-primary, #00b4f3);\n  }\n}\n\n// ─── Searchable picker ───────────────────────────────────────────────────────\n\n.filterSectionBody {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.filterScrollList {\n  max-height: 240px;\n  overflow-y: auto;\n  margin: 0 -2px;\n  padding: 0 2px;\n\n  &::-webkit-scrollbar {\n    width: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: var(--m-scrollbar-color-hovered, #cbd5e1);\n    border-radius: 2px;\n  }\n}\n\n.picker {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.pickerSummary {\n  padding: 8px 10px;\n  border-radius: 6px;\n  background: var(--m-subtle-card-background-color, #f4f6fa);\n  border: 1px solid var(--m-border, #d0d5dd);\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--m-text, #162949);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pickerSearchWrap {\n  position: relative;\n}\n\n.pickerSearchIcon {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--m-text-muted, #6a768b);\n  pointer-events: none;\n}\n\n.pickerSearch {\n  width: 100%;\n  padding: 8px 10px 8px 32px;\n  border-radius: 6px;\n  border: 1px solid var(--m-border, #d0d5dd);\n  background: var(--m-card-background-color, #fff);\n  color: var(--m-text, #162949);\n  font-size: 13px;\n  outline: none;\n\n  &:focus {\n    border-color: var(--m-primary, #00b4f3);\n  }\n\n  &::-webkit-search-cancel-button {\n    cursor: pointer;\n  }\n}\n\n.pickerList {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  max-height: 240px;\n  overflow-y: auto;\n  margin: 0 -2px;\n  padding: 0 2px;\n\n  &::-webkit-scrollbar {\n    width: 4px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: var(--m-scrollbar-color-hovered, #cbd5e1);\n    border-radius: 2px;\n  }\n}\n\n.pickerItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 7px 4px;\n  background: none;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  color: var(--m-text, #162949);\n  font-size: 13px;\n  font-weight: 500;\n  text-align: left;\n  transition: background 0.12s;\n\n  &:hover {\n    background: var(--m-dropdown-hover, #f6f7fb);\n  }\n}\n\n.pickerItemLabel {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pickerHint {\n  padding: 10px 4px;\n  font-size: 12px;\n  color: var(--m-text-muted, #6a768b);\n  text-align: center;\n}\n\n// ─── Period date ─────────────────────────────────────────────────────────────\n\n.periodDate {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.periodDateSelector {\n  width: 100%;\n  max-width: 100%;\n}\n\n.periodModeRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.periodNavRow {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 4px;\n  border-radius: 8px;\n  background: var(--m-subtle-card-background-color, #f4f6fa);\n  border: 1px solid var(--m-border, #d0d5dd);\n}\n\n.periodNavBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: var(--m-card-background-color, #fff);\n  color: var(--m-text, #162949);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: border-color 0.12s, background 0.12s;\n\n  &:hover:not(:disabled) {\n    border-color: var(--m-primary, #00b4f3);\n    color: var(--m-primary, #00b4f3);\n  }\n\n  &:disabled {\n    opacity: 0.35;\n    cursor: not-allowed;\n  }\n}\n\n.periodNavLabel {\n  flex: 1;\n  min-width: 0;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.periodNavPrimary {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--m-text, #162949);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.periodNavSub {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--m-text-muted, #6a768b);\n}\n\n.periodSummary {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px 10px;\n  border-radius: 6px;\n  background: var(--m-subtle-card-background-color, #f4f6fa);\n  border: 1px solid var(--m-border, #d0d5dd);\n}\n\n.periodSummaryLabel {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: var(--m-text-muted, #6a768b);\n}\n\n.periodSummaryValue {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--m-text, #162949);\n}\n\n.periodTodayLink {\n  align-self: flex-start;\n  padding: 0;\n  border: none;\n  background: none;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--m-primary, #00b4f3);\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n@media (max-width: 768px) {\n  .themeScope {\n    position: fixed !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    top: auto !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    border-radius: 12px 12px 0 0;\n    max-height: 85vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ViewOptionsPanel_root__KlB39`,
	"trigger": `ViewOptionsPanel_trigger__1aeWx`,
	"triggerOpen": `ViewOptionsPanel_triggerOpen__owfWf`,
	"triggerLabel": `ViewOptionsPanel_triggerLabel__6EN4r`,
	"badge": `ViewOptionsPanel_badge__BE-g2`,
	"chevron": `ViewOptionsPanel_chevron__qYOnn`,
	"chevronOpen": `ViewOptionsPanel_chevronOpen__7xMb-`,
	"panel": `ViewOptionsPanel_panel__SDiPk`,
	"themeScope": `ViewOptionsPanel_themeScope__mD8Mr`,
	"slideDown": `ViewOptionsPanel_slideDown__4a61D`,
	"dropdownShell": `ViewOptionsPanel_dropdownShell__BfPUb`,
	"body": `ViewOptionsPanel_body__igBEZ`,
	"footer": `ViewOptionsPanel_footer__nLaek`,
	"footerClear": `ViewOptionsPanel_footerClear__f2h9q`,
	"footerApply": `ViewOptionsPanel_footerApply__pGOV6`,
	"section": `ViewOptionsPanel_section__OVokj`,
	"sectionHeader": `ViewOptionsPanel_sectionHeader__YRNWj`,
	"sectionHeaderLeft": `ViewOptionsPanel_sectionHeaderLeft__Vjdo+`,
	"sectionReset": `ViewOptionsPanel_sectionReset__DAI3A`,
	"sectionChevron": `ViewOptionsPanel_sectionChevron__AFO-3`,
	"sectionChevronOpen": `ViewOptionsPanel_sectionChevronOpen__dGNNO`,
	"sectionBody": `ViewOptionsPanel_sectionBody__Ohyee`,
	"chipGrid": `ViewOptionsPanel_chipGrid__PksxN`,
	"chip": `ViewOptionsPanel_chip__bfT54`,
	"chipActive": `ViewOptionsPanel_chipActive__puQN7`,
	"radioList": `ViewOptionsPanel_radioList__Q3Cxm`,
	"radioItem": `ViewOptionsPanel_radioItem__FgoYR`,
	"radioCircle": `ViewOptionsPanel_radioCircle__dEx4A`,
	"radioCircleActive": `ViewOptionsPanel_radioCircleActive__YuRlH`,
	"checkList": `ViewOptionsPanel_checkList__gQ75l`,
	"checkItem": `ViewOptionsPanel_checkItem__NwN0e`,
	"checkBox": `ViewOptionsPanel_checkBox__tDV8g`,
	"checkBoxActive": `ViewOptionsPanel_checkBoxActive__cBNiF`,
	"dateFields": `ViewOptionsPanel_dateFields__mDxg2`,
	"dateField": `ViewOptionsPanel_dateField__ldAH2`,
	"dateLabel": `ViewOptionsPanel_dateLabel__3agyn`,
	"dateInput": `ViewOptionsPanel_dateInput__fjRQ-`,
	"filterSectionBody": `ViewOptionsPanel_filterSectionBody__a9TDb`,
	"filterScrollList": `ViewOptionsPanel_filterScrollList__ckV9x`,
	"picker": `ViewOptionsPanel_picker__8o-Xo`,
	"pickerSummary": `ViewOptionsPanel_pickerSummary__sVHZO`,
	"pickerSearchWrap": `ViewOptionsPanel_pickerSearchWrap__zho8x`,
	"pickerSearchIcon": `ViewOptionsPanel_pickerSearchIcon__QlZBk`,
	"pickerSearch": `ViewOptionsPanel_pickerSearch__RW0hy`,
	"pickerList": `ViewOptionsPanel_pickerList__Gp1OQ`,
	"pickerItem": `ViewOptionsPanel_pickerItem__ojuxm`,
	"pickerItemLabel": `ViewOptionsPanel_pickerItemLabel__2cliD`,
	"pickerHint": `ViewOptionsPanel_pickerHint__U-k0K`,
	"periodDate": `ViewOptionsPanel_periodDate__keCcS`,
	"periodDateSelector": `ViewOptionsPanel_periodDateSelector__lCoqH`,
	"periodModeRow": `ViewOptionsPanel_periodModeRow__qI8J+`,
	"periodNavRow": `ViewOptionsPanel_periodNavRow__mLrod`,
	"periodNavBtn": `ViewOptionsPanel_periodNavBtn__yF9CD`,
	"periodNavLabel": `ViewOptionsPanel_periodNavLabel__OG-q-`,
	"periodNavPrimary": `ViewOptionsPanel_periodNavPrimary__RSyJK`,
	"periodNavSub": `ViewOptionsPanel_periodNavSub__dioke`,
	"periodSummary": `ViewOptionsPanel_periodSummary__asXvB`,
	"periodSummaryLabel": `ViewOptionsPanel_periodSummaryLabel__6wWgV`,
	"periodSummaryValue": `ViewOptionsPanel_periodSummaryValue__1KUAO`,
	"periodTodayLink": `ViewOptionsPanel_periodTodayLink__FY9YV`
};
export default ___CSS_LOADER_EXPORT___;
